import { useNavigate } from "react-router-dom";
import BasePage from "ui/common/components/layout/BasePage/BasePage";
import { MainHeader } from "ui/common/components/navigation/AppBar/AppBarHeader/AppBarHeader.styles";
import AppBarHeaderTitle from "ui/common/components/navigation/AppBar/AppBarHeader/AppBarHeaderTitle";
import HelpList from "ui/common/containers/HelpList/HelpList";

function HelpPage() {
    const navigate = useNavigate();

    function onClickBack() {
        navigate(-1);
    }

    return (
        <BasePage css={{ marginTop: "0px", paddingTop: "0px" }}>
            <MainHeader
                right="support"
                rightColor="primary"
                center={<AppBarHeaderTitle titleColor="black" onClickBack={onClickBack} />}
            />
            <HelpList />
        </BasePage>
    );
}

export default HelpPage;
